//
// ValidationMessage
//
// A validation message.

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { VALIDATION } from '../utils/validation'

export const ValidationMessage = observer(function ValidationMessage(props) {
    const { validation, className, ua, ...other } = props

    const { app } = useStore()

    let uaName = 'ua-message' + (ua ? '-' + ua : '')
    let classes = 'cc-ValidationMessage'
    if (className) classes += ' ' + className

    if (
        !validation ||
        [VALIDATION.SUCCESS, VALIDATION.NA].includes(validation.result)
    ) {
        return null
    }

    if (validation.result === VALIDATION.ERROR) {
        classes += ' validation-error'
    } else if (validation.result === VALIDATION.REPORT) {
        classes += ' validation-report'
    }

    return (
        <div className={classes + ' ' + uaName} {...other}>
            {validation
                .text(app)
                .split('\n')
                .map((line, index) => (
                    <div key={index}>{line}</div>
                ))}
        </div>
    )
})
